import { Box } from "@mui/material";
import React from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { Theme } from "../../../../../../../providers/ThemeProvider";
import CheckWithCircle from "../../../../../svg/CheckWithCircle";
import {
  getStatusBadgeStyle,
  getStatusIconColor,
} from "../../../../../utils/labPanelStatus";

/**
 * "✓ Logged" in the platform's success status badge (the one the lab-panel
 * and InBody screens use), as the mobile details screen shows it. Used on a
 * meal's header in the Day view and in the details panel; the item cards
 * carry only the check (`CheckWithCircle`), as on mobile.
 */
const LoggedBadge = () => {
  const theme: Theme = useTheme();
  return (
    <Box sx={getStatusBadgeStyle("success", theme)}>
      <CheckWithCircle fill={getStatusIconColor("success", theme)} />
      Logged
    </Box>
  );
};

export default LoggedBadge;
